<template>
  <LoadingSpinner v-if="!isReadyPrint" :message="'Đang tải dữ liệu in ...'" />
  <div v-else>
    <div style="margin: 0 20px; font-family: 'Times New Roman', Times, serif">
      <!-- Header -->
      <div class="text-center mb-4">
        <p class="font-size-print font-weight-bold m-0">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
        <p class="font-size-print font-weight-bold m-0">Độc lập – Tự do – Hạnh phúc</p>
        <p class="font-size-print m-0">---o0o---</p>
      </div>

      <div class="text-center mb-4">
        <p class="font-size-title font-weight-bold m-0">HỢP ĐỒNG MUA BÁN HÀNG HÓA</p>
        <p class="font-size-print m-0">
          Số: <strong>{{ bill.einvoice && bill.einvoice.invoiceNo ? bill.einvoice.invoiceNo : '' }}</strong>
        </p>
      </div>

      <div class="mb-3">
        <p class="font-size-print m-0">- Căn cứ Bộ luật Dân sự số 91/2015/QH13 ngày 24/11/2015 và các văn bản pháp luật liên quan;</p>
        <p class="font-size-print m-0">- Căn cứ Luật Thương mại số 36/2005/QH11 ngày 14/06/2005 và các văn bản pháp luật liên quan;</p>
        <p class="font-size-print m-0">- Căn cứ vào nhu cầu và khả năng của các bên;</p>
      </div>

      <p class="font-size-print m-0 mb-3">
        Hôm nay, <strong>{{ formattedCreatedDate }}</strong>, chúng tôi gồm có:
      </p>

      <!-- Bên mua -->
      <div class="mb-3">
        <p class="font-size-print m-0">
          <strong>BÊN MUA ("BÊN A"):</strong>
          <strong>{{ bill.customerCompanyName || bill.customerName }}</strong>
        </p>
        <p class="font-size-print m-0">
          <strong>Địa chỉ:</strong> {{ bill.customerBillAddress || bill.customerAddress }}
        </p>
        <p class="font-size-print m-0">
          <strong>Mã số thuế:</strong> {{ bill.customerTaxCode }}
        </p>
        <p class="font-size-print m-0">
          <strong>Đại diện:</strong> ...................................................................................
        </p>
        <p class="font-size-print m-0">
          <strong>Chức vụ:</strong> ...................................................................................
        </p>
      </div>

      <!-- Bên bán -->
      <div class="mb-4">
        <p class="font-size-print m-0">
          <strong>BÊN BÁN ("BÊN B"):</strong>
          <strong>{{ SUPPLIER_INFO.companyName }}</strong>
        </p>
        <p class="font-size-print m-0">
          <strong>Địa chỉ:</strong> {{ SUPPLIER_INFO.address }}
        </p>
        <p class="font-size-print m-0">
          <strong>Mã số thuế:</strong> {{ SUPPLIER_INFO.taxCode }}
        </p>
        <p class="font-size-print m-0">
          <strong>Đại diện:</strong> ...................................................................................
        </p>
        <p class="font-size-print m-0">
          <strong>Chức vụ:</strong> ...................................................................................
        </p>
        <p class="font-size-print m-0">
          <strong>Tài khoản:</strong> 119002952790 Ngân Hàng TMCP Công Thương Việt Nam (VietinBank) - Chi nhánh 2 TP. HCM
        </p>
      </div>

      <p class="font-size-print mb-3">
        Trên cơ sở thỏa thuận, hai bên thống nhất ký kết hợp đồng mua bán hàng hóa với các điều khoản sau đây:
      </p>

      <!-- Điều 1 -->
      <p class="font-size-print font-weight-bold mb-2">ĐIỀU 1. TÊN HÀNG - SỐ LƯỢNG - GIÁ TRỊ HỢP ĐỒNG:</p>
      <p class="font-size-print text-right m-0">Đơn vị tính: VNĐ</p>

      <table class="table table-bordered-print col-md-12 mb-3" style="table-layout: fixed; width: 100%">
        <colgroup>
          <col style="width: 5%" />
          <col style="width: 51%" />
          <col style="width: 6%" />
          <col style="width: 6%" />
          <col style="width: 7%" />
          <col style="width: 12%" />
          <col style="width: 13%" />
        </colgroup>
        <tr>
          <th class="text-center font-size-print">STT</th>
          <th class="font-size-print">TÊN HÀNG HÓA, DỊCH VỤ</th>
          <th class="text-center font-size-print">ĐƠN VỊ TÍNH</th>
          <th class="text-center font-size-print">SỐ LƯỢNG</th>
          <th class="text-center font-size-print">VAT</th>
          <th class="text-center font-size-print">ĐƠN GIÁ GỒM VAT</th>
          <th class="text-center font-size-print">THÀNH TIỀN</th>
        </tr>
        <template v-for="(item, index) in groupedItems">
          <tr v-if="item.billItemType === BILL_ITEM_TYPE_PRODUCT" :key="'item-' + index">
            <td class="text-center align-middle font-size-print">{{ item.stt }}</td>
            <td class="align-middle font-size-print">{{ item.name }}</td>
            <td class="text-center align-middle font-size-print print-uom">{{ item.productUnit || 'Cái' }}</td>
            <td class="text-center align-middle font-size-print print-qty">{{ item.quantity }}</td>
            <td class="text-center align-middle font-size-print">8%</td>
            <td class="text-right align-middle font-size-print">{{ convertPrice(item.price) }}</td>
            <td class="text-right align-middle font-size-print">{{ convertPrice(item.price * item.quantity) }}</td>
          </tr>
        </template>
        <tr>
          <td colspan="6" class="text-right align-middle font-size-print font-weight-bold">
            Tổng thanh toán (đã bao gồm 8% VAT)
          </td>
          <td class="text-right align-middle font-size-print font-weight-bold">
            {{ convertPrice(bill.totalAmount) }}
          </td>
        </tr>
      </table>

      <p class="font-size-print mb-2">
        <strong>Số tiền bằng chữ (đã bao gồm VAT):</strong> {{ bill.textTotalAmount }}.
      </p>
      <p class="font-size-print mb-3">
        Giá đã bao gồm thuế GTGT và các chi phí trong quá trình giao hàng tới địa chỉ mà bên B chỉ định tại Hợp đồng. Bộ máy bao gồm máy và đầy đủ phụ kiện đi kèm. Hàng mới 100% và được bảo hành theo chính sách của nhà sản xuất.
      </p>

      <!-- Điều 2 -->
      <p class="font-size-print font-weight-bold mb-2">ĐIỀU 2. THANH TOÁN:</p>
      <p class="font-size-print m-0">
        <strong>1. Thời hạn thanh toán:</strong> Bên A có trách nhiệm thanh toán 01 lần đủ 100% giá trị của hợp đồng trước khi bên B tiến hành giao hàng. Bên B sau khi nhận được tiền có trách nhiệm hoàn tất quá trình cung cấp các thiết bị hàng hóa và chứng từ liên quan ghi tại Điều 1 của Hợp đồng.
      </p>
      <p class="font-size-print m-0 mb-3">
        <strong>2. Hình thức thanh toán:</strong> Bên A thanh toán cho Bên B theo hình thức chuyển khoản vào tài khoản của Bên B chi tiết như sau:<br />
        Đơn vị thụ hưởng: CÔNG TY TNHH TM VÀ XNK TRẦN NGỌC<br />
        Số tài khoản: 119002952790 Ngân Hàng TMCP Công Thương Việt Nam (VietinBank) - Chi nhánh 2 TP. HCM
      </p>

      <!-- Điều 3 -->
      <p class="font-size-print font-weight-bold mb-2">ĐIỀU 3: BẢO HÀNH SẢN PHẨM</p>
      <p class="font-size-print mb-3">
        Sản phẩm do Bên B cung cấp cho Bên A đảm bảo mới 100%, chính hãng sản xuất, đúng các chỉ tiêu kỹ thuật và xuất xứ model như đã nêu trong bảng báo giá. Sản phẩm do Bên B cung cấp được bảo hành chính hãng, tuân thủ theo các qui định, điều khoản, chính sách &amp; thời gian bảo hành của nhà sản xuất.
      </p>

      <!-- Điều 4 -->
      <p class="font-size-print font-weight-bold mb-2">ĐIỀU 4: THỜI GIAN, ĐỊA ĐIỂM VÀ PHƯƠNG THỨC GIAO HÀNG:</p>
      <p class="font-size-print m-0">Thời gian giao hàng: Trong vòng 10 ngày sau khi Bên A thanh toán đầy đủ cho Bên B. (Không tính ngày nghỉ Lễ, Tết)</p>
      <p class="font-size-print m-0">Địa chỉ: {{ bill.customerBillAddress || bill.customerAddress }}.</p>
      <p class="font-size-print m-0">Hồ sơ giao hàng gồm: Biên bản bàn giao hàng hóa. Hóa đơn tài chính. Danh sách imei/serial number cùng các chứng từ theo quy định hiện hành của Nhà nước.</p>

      <!-- Điều 5 -->
      <p class="font-size-print font-weight-bold mt-3 mb-2">ĐIỀU 5: TRÁCH NHIỆM CỦA CÁC BÊN</p>
      <p class="font-size-print m-0">
        Bên B có nghĩa vụ giao hàng đúng thời gian, địa điểm và số lượng, đảm bảo hàng hóa <strong>mới 100%</strong> có nguồn gốc rõ ràng và đáp ứng đầy đủ tiêu chí về chất lượng, chủng loại hàng hóa đã quy định tại Điều 1 của Hợp đồng này.
      </p>
      <p class="font-size-print m-0 mb-3">
        Bên A đảm bảo có đầy đủ chức năng thực hiện công việc theo Hợp đồng này. Bên A tạo điều kiện thuận lợi và cử người phối hợp với Bên B trong công việc giao nhận hàng hóa. Bên A đảm bảo việc thanh toán đúng theo Điều 2 của Hợp đồng này.
      </p>

      <!-- Điều 6 -->
      <p class="font-size-print font-weight-bold mb-2">ĐIỀU 6: XỬ LÝ VI PHẠM HỢP ĐỒNG</p>
      <p class="font-size-print mb-3">
        Ngoại trừ việc chậm trễ do trường hợp bất khả kháng, trong trường hợp vi phạm thời gian giao hàng và không có biện pháp khắc phục thì Bên B sẽ chịu phạt với mức phạt vi phạm 0.1%/ngày trên tổng giá trị khi vi phạm hợp đồng.
        Tổng mức phạt không vượt quá 8% tổng giá trị Hợp đồng bị vi phạm.
        Trường hợp Bên A chậm thanh toán sẽ chịu mức phạt 0.1%/ngày trên số tiền chậm. Tổng không vượt 8% giá trị HĐ.
        Bên A kiểm tra ngay khi nhận. Trong 24 giờ nếu phát hiện sai lệch hàng hóa, giá trị hóa đơn, imei, và tình trạng hàng hóa phải thông báo cho bên B bằng văn bản.
      </p>

      <!-- Điều 7 -->
      <p class="font-size-print font-weight-bold mb-2">ĐIỀU 7: BẤT KHẢ KHÁNG VÀ GIẢI QUYẾT TRANH CHẤP:</p>
      <p class="font-size-print mb-3">
        Trừ các trường hợp bất khả kháng, hai bên phải thực hiện đầy đủ và đúng thời hạn các nội dung của hợp đồng này.
        Trong quá trình thực hiện hợp đồng, nếu có vướng mắc từ bất kỳ bên nào, hai bên sẽ cùng nhau giải quyết trên tinh thần hợp tác.
        Trong trường hợp không tự giải quyết được, hai bên thống nhất đưa ra giải quyết tại Tòa án có thẩm quyền tại TP. Hồ Chí Minh.
      </p>

      <!-- Điều 8 -->
      <p class="font-size-print font-weight-bold mb-2">ĐIỀU 8: ĐIỀU KHOẢN CHUNG:</p>
      <p class="font-size-print mb-4">
        Hợp đồng này có giá trị thay thế mọi giao dịch, thỏa thuận trước đây của hai bên. Mọi sự bổ sung, sửa đổi hợp đồng này đều phải có sự đồng ý bằng văn bản của hai bên. Hợp đồng này được lập thành <strong>04 (bốn)</strong> bản. Mỗi bên giữ <strong>02 (hai)</strong> bản, có giá trị pháp lý như nhau.
      </p>

      <!-- Ký tên -->
      <b-row class="mt-4">
        <b-col class="text-center">
          <p class="font-size-print font-weight-bold m-0">Đại diện Bên A</p>
          <p class="font-size-print m-0">(Ký và đóng dấu)</p>
          <br /><br /><br />
          <!-- <p class="font-size-print m-0">{{ bill.customerCompanyName || bill.customerName }}</p> -->
        </b-col>
        <b-col class="text-center">
          <p class="font-size-print font-weight-bold m-0">Đại diện Bên B</p>
          <p class="font-size-print m-0">(Ký và đóng dấu)</p>
          <br /><br /><br />
          <!-- <p class="font-size-print m-0">{{ SUPPLIER_INFO.companyName }}</p> -->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { convertPrice, cloneDeep } from '@/utils/common';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import { BILL_ITEM_TYPE } from '@/utils/enum';
import { SUPPLIER_INFO } from '@/utils/constants';
import { groupBy } from 'lodash';

export default {
  name: 'PrintBillHopDong',
  components: { LoadingSpinner },
  props: ['printData'],
  data() {
    return {
      SUPPLIER_INFO,
      BILL_ITEM_TYPE_PRODUCT: BILL_ITEM_TYPE.PRODUCT,
      bill: {},
      groupedItems: [],
      isReadyPrint: false,
    };
  },
  watch: {
    printData: {
      async handler(newPrintData) {
        if (!newPrintData?.bill) return;
        const billCopy = cloneDeep(newPrintData.bill);
        this.groupedItems = this.groupBillItems(billCopy.listBillItem || []);
        this.bill = billCopy;
        await this.$nextTick();
        setTimeout(() => {
          this.isReadyPrint = true;
        }, 500);
      },
      deep: false,
      immediate: true,
    },
  },
  computed: {
    formattedCreatedDate() {
      if (!this.bill?.createdAt) return '';
      const date = this.bill.createdAt.split(' ')[1];
      const [day, month, year] = date.split('/');
      return `Ngày ${day} tháng ${month} năm ${year}`;
    },
  },
  methods: {
    convertPrice,
    groupBillItems(listBillItems) {
      const grouped = groupBy(listBillItems, (item) => `${item.id}_${item.price}`);
      return Object.keys(grouped).map((key) => {
        const items = grouped[key];
        const info = items[0];
        return {
          ...info,
          quantity: items.reduce((acc, { quantity }) => acc + quantity, 0),
        };
      });
    },
  },
};
</script>

<style scoped>
.font-size-print {
  font-size: 11px;
  color: black;
}
.font-size-title {
  font-size: 15px;
  color: black;
}
.table-bordered-print th,
.table-bordered-print td {
  border: 0.5px solid #474545;
  padding: 3px 5px;
}
</style>
